export default {
  SET_SELECT_SECRETARY(state,Secretary){
      state.selectSecretary = Secretary
  },
  SET_RESULT(state,result){
      state.Result = result
  },
  SET_EDIT_SECRETARY(state,editSecretary){
      state.editSecretary = editSecretary
  },
}